import type { TFunction } from "i18next";
import { ApiError } from "../../api/client";

// Cod de eroare din backend ({error: "..."}) → mesaj tradus; altfel textul brut.
export function stockErrorMessage(e: unknown, t: TFunction): string {
  if (e instanceof ApiError) {
    const code = (e.detail as { error?: string } | null)?.error;
    if (code) return t(`stock.errors.${code}`, { defaultValue: code });
    return e.message;
  }
  return String(e);
}
